<script setup lang="ts">
import Status from '../tnm/StatusComponenet.vue'
definePage({
  meta: {
    action: 'manage',
    subject: 'TCA',
  },
})

interface Props {
  isShow: boolean[],
  applyNo: string,
  status: string,
  // 傳入userNo
  userInfo: string,
  statusComponent: string,
}

const props = withDefaults(defineProps<Props>(), {
  isShow: () => [true, true, true, true],
  applyNo: '',
  status: '',
  userInfo: '',
  statusComponent: '',
})

const compId = ref('nstc')
const userData = useStorage<any>('userData', {}).value;
const user = reactive<any>({})
const displayStatus = computed(() => props.applyNo ? props.status : '');

// 取得人員資料API
const fetchUser = async (userNo: string) => {
  try {
    const resp = await $api('/tca/userInfo/loadUser', {
      method: 'GET',
      query: {
        compNo: compId.value,
        userNo: props.userInfo,
      },
    });
    return resp;
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }
}

watch(() => props.userInfo, async () => {
  if (props.userInfo) {
    const userData = await fetchUser(props.userInfo);
    if (userData) {
      Object.assign(user, userData);
    }
  }
});

onMounted(async () => {
  if (props && props.userInfo) {
    const userData = await fetchUser(props.userInfo);
    if (userData) {
      Object.assign(user, userData);
    }
  }
});
</script>


<template>
  <v-col v-if="props.isShow[0]" cols="6">
    <v-list-item>
      <v-list-item-title>申請人</v-list-item-title>
      <v-list-item-subtitle>{{ user.cname ? user.cname : userData.name }}</v-list-item-subtitle>
      <v-list-item-subtitle>{{ user.userNo ? user.userNo : userData.userno }}</v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <v-col v-if="props.isShow[1]" cols="6">
    <v-list-item>
      <v-list-item-title>單位</v-list-item-title>
      <v-list-item-subtitle>{{ user.depNo ? toText(user.depNo) : userData.depNo }} </v-list-item-subtitle>
      <v-list-item-subtitle>{{ user.depNo ? toCode(user.depNo) : userData.depNo }} </v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <v-col v-if="props.isShow[2]" cols="6">
    <v-list-item>
      <v-list-item-title>申請單號</v-list-item-title>
      <v-list-item-subtitle>{{ props.applyNo }}</v-list-item-subtitle>
    </v-list-item>
  </v-col>
  <slot name="extra"></slot>
  <v-col v-if="props.isShow[3] && props.applyNo" cols="12" style="overflow: visible !important;">
    <v-list-item style="overflow: visible !important;">
      <div class="d-flex align-center" style="overflow: visible !important;">
        <v-list-item-title class="me-8" style="flex: 0 0 auto; width: auto;">狀態</v-list-item-title>
        <div style="overflow: visible !important;">
          <Status
            :status="displayStatus"
            :is-red="['Rejected', 'Revoke', 'Revoked']"
            :is-green="['FPassed', 'FApproved', 'SendAfterCorrect']"
            :is-warning="['Draft']"
            :is-info="[]"
            :is-purple="['ReturnedForRevision', 'MReturnedForRevision', 'CorrectAfterApprove']"
            :is-teal="['Reviewing', 'MApproved']"
            :is-indigo="['Resubmitted', 'MPassed']"
            :is-primary="['Submitted', 'FReturnedForRevision']"
            :is-secondary="['Closed']"
            :shared-table-id="props.statusComponent"
            btn-class="x-large"
            font-class="18px"
          />
        </div>
      </div>
    </v-list-item>
  </v-col>
</template>
